import { createActionGroup, emptyProps } from "@ngrx/store";

export const ToggleMobileMenuActions = createActionGroup({
    source: 'Toggle mobile menu',
    events: {
        toggle: emptyProps(),
    },
});